import { FunctionDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const ApiGet = () => (
  <FunctionDocs entry="apiGet">
    <ComponentExample
      name="GET request"
      rawImport={import("examples/Api/ApiGet/GetRequestExample?raw")}
    />
    <ComponentExample
      name="Request with query parameters"
      rawImport={import("examples/Api/ApiGet/GetRequestQueryParamsExample?raw")}
    />
    <ComponentExample
      name="Request with advanced options"
      rawImport={import(
        "examples/Api/ApiGet/GetRequestAdvancedOptionsExample?raw"
      )}
    />
  </FunctionDocs>
);

export default ApiGet;
